import { Navigate } from "react-router-dom";
import {
  BASE_ROUTE,
  ANALYTICS_ROUTE,
  OVERVIEW_ROUTE,
  routesMap,
} from "@/components/routes/routes";
import storageService from "@/services/middleware/storageService";
import { LOCAL_STORAGE_KEY_PREFIX } from "@/utilities/configurations";

const LoginAsUser = () => {
  const searchParams = new URLSearchParams(location.search);
  const tokenFromUrl: string | null = searchParams.get("t");
  const relationshipFromUrl: number | null = parseInt(
    searchParams.get("r") as string,
    10
  );
  const roleFromUrl: string | null = searchParams.get("g");
  const redirectionFromUrl:
    | "enabled_only"
    | "enabled_and_default_landing"
    | string
    | null = searchParams.get("h");

  if (
    !tokenFromUrl ||
    !relationshipFromUrl ||
    Number.isNaN(relationshipFromUrl) ||
    !roleFromUrl
  ) {
    return <Navigate to={routesMap.auth.login.pathWithSearch} />;
  } else {
    localStorage.clear();
    sessionStorage.clear();
    if (roleFromUrl === "ghost-admin") {
      sessionStorage.setItem(
        `${LOCAL_STORAGE_KEY_PREFIX}is-ghost`,
        JSON.stringify(true)
      );
      sessionStorage.setItem(
        `${LOCAL_STORAGE_KEY_PREFIX}ghost-role`,
        roleFromUrl
      );
    }

    setTimeout(() => {
      storageService.setItem("token", tokenFromUrl);
      storageService.setItem("activeRelationshipId", relationshipFromUrl);
      switch (redirectionFromUrl) {
        case "enabled_and_default_landing":
          window.location.href = OVERVIEW_ROUTE;
          break;
        case "enabled_only":
          window.location.href = ANALYTICS_ROUTE;
          break;
        default:
          window.location.href = BASE_ROUTE;
          break;
      }
    }, 300);
    return null;
  }
};

export default LoginAsUser;
